import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Branch, BranchCreate, BranchFilter } from '../data/branch';

export function createBranchService(client: AxiosInstance) {
  return createCrudService<Branch, BranchCreate, BranchFilter>(
    client,
    '/tenancy/Branch',
    'branchId',
  );
}

export type BranchService = CrudService<Branch, BranchCreate, BranchFilter>;
